import UrunlerService from "../../../services/UrunlerService";

export default {
  namespaced: true,
  state: () => ({
    urunListesi: [],
    urunSayisi: 0,
    urunAramaSonucu: [],
    islemGorenUrunler: [],
    islemGorenUrun: [],
  }),
  mutations: {
    setUrunListesi: (state, list) => {
      state.urunListesi = list;
    },
    urunSayisi: (state, count) => {
      state.urunSayisi = count;
    },
    setUrunArama: (state, list) => {
      state.urunAramaSonucu = list;
    },
    setIslemGorenUrunler: (state, list) => {
      state.islemGorenUrunler = list;
    },
    setIslemGorenUrun: (state, list) => {
      state.islemGorenUrun = list;
    },
  },
  actions: {
    urunListesi: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunListesi(data)
          .then((res) => {
            commit("setUrunListesi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunSayisi: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunSayisi(data)
          .then((res) => {
            commit("urunSayisi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunAraSayisi: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunAraSayisi(data)
          .then((res) => {
            commit("urunSayisi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunAra: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunAra(data)
          .then((res) => {
            commit("setUrunArama", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunleriYayinaAl: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunleriYayinaAl(data)
          .then((res) => {
            dispatch("setIslemGorenUrunler", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunleriYayindanKaldir: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunleriYayindanKaldir(data)
          .then((res) => {
            dispatch("setIslemGorenUrunler", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    urunleriSistemdenKaldir: ({ dispatch }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.urunleriSistemdenKaldir(data)
          .then((res) => {
            dispatch("setIslemGorenUrunler", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    yayinaAl: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.yayinaAl(data)
          .then((res) => {
            commit("setIslemGorenUrun", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    yayindanKaldir: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.yayindanKaldir(data)
          .then((res) => {
            commit("setIslemGorenUrun", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sistemdenKaldir: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        UrunlerService.sistemdenKaldir(data)
          .then((res) => {
            commit("setIslemGorenUrun", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};